'use client'

import AppContext from "AppContext";
import GeneralForm from "components/GeneralForm";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import TabPanel from "components/TabPanel";
import TabView from "components/TabView";
import { validate } from "components/validateGeneralForm";
import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Alert, Button, Card, CardBody, Container, Modal, ModalBody, ModalFooter, Table } from "reactstrap";
import comboService from "services/ComboService";
import equipeService from "services/EquipeService";
import usuarioService from "services/UsuarioService";
import { erroInesperado } from "services/Utils";
import veiculoService from "services/VeiculoService";
import { confirm } from "components/Confirmation";
import IconButton from "components/IconButton";

export default function FormEquipe() {
  const { state } = useContext(AppContext)
  const [data, setData] = useState({
    idEmpresa: state.user?.empresa?.id
  })
  const [originalData, setOriginalData] = useState()
  const [veiculos, setVeiculos] = useState([])
  const [veiculosEquipe, setVeiculosEquipe] = useState([])
  const [executores, setExecutores] = useState([])
  const [edit, setEdit] = useState(false)
  const [idVeiculoSelecionado, setIdVeiculoSelecionado] = useState()
  const [modalRealocarVeiculo, setModalRealocarVeiculo] = useState()
  const [modalRealocarEncarregado, setModalRealocarEncarregado] = useState()
  const params = useParams()
  const navigate = useNavigate()

  const podeGerenciar = (state?.user?.acoes || []).includes('equipe.gerenciar')

  const id = parseInt(params.id)
  const novo = (0 === id)

  useEffect(() => {
    if (!!id) {
      equipeService.getById(id).then(res => {
        if (res.success) {
          setData({
            ...res.data,
            idEncarregadoAtual: res.data.encarregadoAtual?.id
          })
          setOriginalData(res.data)
        }
      })
      carregarVeiculosEquipe(id)
    } else {
      setData({
        idEmpresa: state.user?.empresa?.id
      })
    }
  }, [id])

  const carregarVeiculosEquipe = async (idEquipe) => {
    try {
      const res = await equipeService.listarVeiculos(idEquipe)
      if (res.success) {
        setVeiculosEquipe(res.data || [])
      }
    } catch (ex) {
      console.log('Erro ao carregar veículos da equipe', ex)
    }
  }

  useEffect(() => {
    setData(data => ({
      ...data,
      idEmpresa: state.user?.empresa?.id
    }))
  }, [state.user?.empresa?.id])

  useEffect(() => {
    if (novo) {
      setEdit(true)
    }
  }, [novo])

  useEffect(() => {
    comboService.veiculos(data.idEmpresa).then(res => {
      if (res.success) {
        setVeiculos(res.data)
      } else {
        setVeiculos([])
      }
    })

    comboService.executor(data.idEmpresa).then(res => {
      if (res.success) {
        setExecutores(res.data)
      } else {
        setExecutores([])
      }
    })
  }, [data.idEmpresa])

  useEffect(() => {
    const verificarRealocacao = async () => {
      if (data && originalData?.encarregadoAtual?.id != data.idEncarregadoAtual) {
        const { success, data: equipe } = await usuarioService.getEquipeAtualById(data.idEncarregadoAtual)
        if (success) {
          if (equipe && equipe.id != id) {
            setModalRealocarEncarregado({
              nome: executores.find(e => e.id == data.idEncarregadoAtual).nome,
              equipeAtual: equipe.nome,
              novaEquipe: data.nome,
            })
            return
          }
        }
      }
    }
    verificarRealocacao()
  }, [originalData, data.idEncarregadoAtual])

  const formConfig = useMemo(() => {
    return [
      [
        { name: "nome", label: 'Nome', type: "text", required: true, colspan: 12 },
        { name: "idEncarregadoAtual", label: 'Encarregado', type: "combo", options: executores.map(el => ({ value: el.id, label: el.nome })), showDefault: true, defaultValue: 'Nenhum', colspan: 6 },
      ]
    ]
  }, [executores])

  const veiculosDisponiveis = useMemo(() => {
    return veiculos.filter(v => !veiculosEquipe.some(ve => ve.id === v.id))
  }, [veiculos, veiculosEquipe])

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const recusarRealocacaoEncarregado = () => {
    setData({ ...data, idEncarregadoAtual: originalData?.encarregadoAtual?.id })
    setModalRealocarEncarregado()
  }

  const confirmarRealocacaoEncarregado = () => {
    setModalRealocarEncarregado()
  }

  const handleAdicionarVeiculo = async () => {
    if (!idVeiculoSelecionado) {
      toast('Selecione um veículo')
      return
    }

    const veiculo = veiculos.find(v => v.id === idVeiculoSelecionado)

    if (veiculo.equipeAtualId && veiculo.equipeAtualId !== id) {
      setModalRealocarVeiculo({
        idVeiculo: idVeiculoSelecionado,
        placa: veiculo.placa,
        marcaModelo: veiculo.marcaModelo,
        equipeAtual: veiculo.equipeAtualNome,
        novaEquipe: data.nome,
      })
      return
    }

    try {
      await equipeService.atribuirVeiculo(id, idVeiculoSelecionado)
      toast('Veículo atribuído com sucesso!')
      setIdVeiculoSelecionado()
      carregarVeiculosEquipe(id)
    } catch (ex) {
      erroInesperado()
    }
  }

  const handleSelecionarVeiculo = async (idVeiculo) => {
    setIdVeiculoSelecionado(idVeiculo)

    if (!idVeiculo) {
      return
    }

    try {
      const { success, data: veiculo } = await veiculoService.getById(idVeiculo)
      if (success && veiculo?.equipeAtual && veiculo.equipeAtual.id != id) {
        setModalRealocarVeiculo({
          idVeiculo,
          placa: veiculo.placa,
          marcaModelo: veiculo.marcaModelo,
          equipeAtual: veiculo.equipeAtual.nome,
          novaEquipe: data.nome,
        })
      }
    } catch (ex) {
      erroInesperado()
    }
  }

  const handleRemoverVeiculo = (idVeiculo) => {
    confirm({
      text: 'Deseja remover este veículo da equipe?',
      icon: 'bi-exclamation-triangle',
      onConfirm: async () => {
        try {
          await equipeService.removerVeiculo(id, idVeiculo)
          toast('Veículo removido com sucesso!')
          carregarVeiculosEquipe(id)
        } catch (ex) {
          erroInesperado()
        }
      }
    })
  }

  const confirmarRealocacaoVeiculo = async () => {
    try {
      await equipeService.atribuirVeiculo(id, modalRealocarVeiculo.idVeiculo)
      toast('Veículo realocado com sucesso!')
      setIdVeiculoSelecionado()
      setModalRealocarVeiculo()
      carregarVeiculosEquipe(id)
    } catch (ex) {
      erroInesperado()
    }
  }

  const recusarRealocacaoVeiculo = () => {
    setModalRealocarVeiculo()
    setIdVeiculoSelecionado()
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      if (novo) {
        await equipeService.create(data)
      } else {
        await equipeService.update(id, data)
      }
      toast('Registro salvo com sucesso!')
      navigate(`/admin/equipes`)
    } catch (ex) {
      erroInesperado()
    }
  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Equipes" edit={edit} onChangeEdit={setEdit} showButton={!novo && podeGerenciar} />
      <TabView defaultTab="dados">
        <TabPanel label="Dados" id="dados">
          <form onSubmit={handleSubmit}>
            <GeneralForm
              config={formConfig}
              data={data}
              onChange={handleChange}
              disabled={!edit}
            />
            {edit && (
              <Button type="submit" color="primary">Salvar</Button>
            )}
          </form>
        </TabPanel>

        <TabPanel label="Veículos" id="veiculos" disabled={novo}>
          <h4 className="mb-3">Veículos da Equipe</h4>

          {veiculosEquipe.length > 0 && (
            <Table striped className="mb-4">
              <thead>
                <tr>
                  <th>Placa</th>
                  <th>Marca/Modelo</th>
                  {podeGerenciar && (
                    <th style={{ width: '80px' }}>Ações</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {veiculosEquipe.map(veiculo => (
                  <tr key={veiculo.id}>
                    <td>{veiculo.placa}</td>
                    <td>{veiculo.marcaModelo}</td>
                    {podeGerenciar && (
                      <td>
                        <IconButton
                          alt="Remover"
                          iconClass="bi-trash"
                          onClick={() => handleRemoverVeiculo(veiculo.id)}
                        />
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          )}

          {veiculosEquipe.length === 0 && (
            <Alert color="info" className="mb-4">
              Nenhum veículo atribuído a esta equipe
            </Alert>
          )}

          {veiculosDisponiveis.length > 0 && podeGerenciar && (
            <Card className="bg-light">
              <CardBody>
                <h5 className="mb-3">Adicionar Veículo</h5>
                <div className="row">
                  <div className="col-8">
                    <select
                      className="form-control"
                      value={idVeiculoSelecionado || ''}
                      onChange={(e) => handleSelecionarVeiculo(e.target.value ? parseInt(e.target.value) : null)}
                    >
                      <option value="">Selecione um veículo</option>
                      {veiculosDisponiveis.map(veiculo => (
                        <option key={veiculo.id} value={veiculo.id}>
                          {veiculo.marcaModelo} - {veiculo.placa}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-4">
                    <Button
                      color="primary"
                      onClick={handleAdicionarVeiculo}
                      disabled={!idVeiculoSelecionado}
                    >
                      Adicionar
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>
          )}
        </TabPanel>
      </TabView>

      <Modal isOpen={!!modalRealocarVeiculo}>
        <div className="modal-header d-flex justify-content-center">
          <h3 className="modal-title" id="exampleModalLabel">
            <i className="bi bi-exclamation-triangle"></i> Veículo já alocado
          </h3>
        </div>
        <ModalBody>
          <p>O veículo <strong>{modalRealocarVeiculo?.marcaModelo}</strong> com placa <strong>{modalRealocarVeiculo?.placa}</strong> está atualmente vinculado à <strong>Equipe {modalRealocarVeiculo?.equipeAtual}</strong>.</p>
          <p>Deseja realocar este veículo para a <strong>Equipe {modalRealocarVeiculo?.novaEquipe}</strong>?</p>
          <Alert color="info">A equipe {modalRealocarVeiculo?.equipeAtual} ficará sem este veículo vinculado.</Alert>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="primary" onClick={() => recusarRealocacaoVeiculo()}>Não</Button>
          <Button type="button" color="danger" onClick={() => confirmarRealocacaoVeiculo()}>Realocar Veículo</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={!!modalRealocarEncarregado}>
        <div className="modal-header d-flex justify-content-center">
          <h3 className="modal-title" id="exampleModalLabel">
            <i className="bi bi-exclamation-triangle"></i> Encarregado já alocado
          </h3>
        </div>
        <ModalBody>
          <p>O encarregado <strong>{modalRealocarEncarregado?.nome}</strong> está atualmente vinculado à <strong>Equipe {modalRealocarEncarregado?.equipeAtual}</strong>.</p>
          <p>Deseja realocar este encarregado para a <strong>Equipe {modalRealocarEncarregado?.novaEquipe}</strong>?</p>
          <Alert color="info">A equipe {modalRealocarEncarregado?.equipeAtual} ficará sem encarregado vinculado.</Alert>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="primary" onClick={() => recusarRealocacaoEncarregado()}>Não</Button>
          <Button type="button" color="danger" onClick={() => confirmarRealocacaoEncarregado()}>Realocar Encarregado</Button>
        </ModalFooter>
      </Modal>
    </Container>
  )
}